import React from "react";

export default ({ type, children, phase = "normal" }) => (
  <button type={type} className="o-sqgradbtn">
    {children}{" "}
    {phase === "normal" && (
      <i className="fa fa-angle-double-right o-btn--arrow" aria-hidden="true" />
    )}
    {phase === "loading" && (
      <i className="fa fa-spinner fa-spin" aria-hidden="true" />
    )}
    {phase === "done" && <i className="fa fa-check" aria-hidden="true" />}
    {phase === "error" && (
      <i className="fa fa-exclamation-triangle" aria-hidden="true" />
    )}
  </button>
);



// WEBPACK FOOTER //
// ./src/molecules/Sqgradbtn.js